<template>
  <div>
    <!-- 列表模式 -->
    <template v-if="!printMode">
    <a-card :bordered="false" title="凭证列表">
      <div class="table-operator" style="margin-bottom: 12px;">
        <span>期间：</span>
        <a-month-picker v-model="period" format="YYYY-MM" @change="onPeriodChange" style="width: 140px;" />
        <a-button style="margin-left: 8px" @click="loadData">刷新</a-button>
        <a-button style="margin-left: 8px" icon="setting" @click="openRulePage">规则</a-button>
        <!-- 查询按钮：点击在下方弹出的筛选面板（DOM/CSS 照抄 凭证查询.html） -->
        <span class="query-trigger">
          <a-button icon="search" @click.stop="toggleQueryPanel">查询</a-button>
          <div v-if="queryVisible" class="h-dropdown" @click.stop>
            <div class="h-dropdown-inner">
              <div style="padding-top:20px;width:400px;height:325px;">
                <div class="h-form h-form-single h-form-label-right" style="width:380px;">
                  <div class="h-form-item">
                    <label class="h-form-item-label" style="width:100px"><span>凭证字：</span></label>
                    <div class="h-form-item-content" style="margin-left:100px">
                      <div class="h-form-item-wrap">
                        <div class="h-select h-select-input-border h-select-no-autosize" @click.stop="toggleSelect('voucherWord')">
                          <div class="h-select-show">
                            <div v-if="queryParam.voucherWord == null" class="h-select-placeholder">全部</div>
                            <div v-else class="h-select-selection">{{ voucherWordLabel }}</div>
                            <i class="h-icon-down">▾</i>
                          </div>
                          <div v-if="selectOpen === 'voucherWord'" class="h-select-group h-select-single">
                            <div class="h-select-item" @click.stop="setQuery('voucherWord', null)">全部</div>
                            <div class="h-select-item" v-for="w in voucherWords" :key="w.id" @click.stop="setQuery('voucherWord', w.id)">{{ w.word }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="h-form-item">
                    <label class="h-form-item-label" style="width:100px"><span>制单人：</span></label>
                    <div class="h-form-item-content" style="margin-left:100px">
                      <div class="h-form-item-wrap">
                        <div class="h-select h-select-input-border h-select-no-autosize" @click.stop="toggleSelect('createMember')">
                          <div class="h-select-show">
                            <div v-if="queryParam.createMember == null" class="h-select-placeholder">全部</div>
                            <div v-else class="h-select-selection">{{ createMemberLabel }}</div>
                            <i class="h-icon-down">▾</i>
                          </div>
                          <div v-if="selectOpen === 'createMember'" class="h-select-group h-select-single">
                            <div class="h-select-item" @click.stop="setQuery('createMember', null)">全部</div>
                            <div class="h-select-item" v-for="u in userList" :key="u.id" @click.stop="setQuery('createMember', u.id)">{{ u.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="h-form-item">
                    <label class="h-form-item-label" style="width:100px"><span>摘要：</span></label>
                    <div class="h-form-item-content" style="margin-left:100px">
                      <div class="h-form-item-wrap"><input type="text" placeholder="请输入" v-model="queryParam.summary"></div>
                    </div>
                  </div>
                  <div class="h-form-item">
                    <label class="h-form-item-label" style="width:100px"><span>备注：</span></label>
                    <div class="h-form-item-content" style="margin-left:100px">
                      <div class="h-form-item-wrap"><input type="text" placeholder="请输入" v-model="queryParam.remark"></div>
                    </div>
                  </div>
                  <div class="h-form-item">
                    <label class="h-form-item-label" style="width:100px"><span>来源单据：</span></label>
                    <div class="h-form-item-content" style="margin-left:100px">
                      <div class="h-form-item-wrap"><input type="text" placeholder="请输入来源单据号" v-model="queryParam.sourceBillNo"></div>
                    </div>
                  </div>
                  <div class="h-form-item">
                    <label class="h-form-item-label" style="width:100px"><span>科目：</span></label>
                    <div class="h-form-item-content" style="margin-left:100px">
                      <div class="h-form-item-wrap">
                        <div class="h-select h-select-input-border h-select-no-autosize" @click.stop="toggleSelect('subjectId')">
                          <div class="h-select-show">
                            <div v-if="queryParam.subjectId == null" class="h-select-placeholder">全部</div>
                            <div v-else class="h-select-selection">{{ subjectLabel }}</div>
                            <i class="h-icon-down">▾</i>
                          </div>
                          <div v-if="selectOpen === 'subjectId'" class="h-select-group h-select-single">
                            <div class="h-select-item" @click.stop="setQuery('subjectId', null)">全部</div>
                            <div class="h-select-item" v-for="s in subjects" :key="s.id" @click.stop="setQuery('subjectId', s.id)">{{ s.subjectCode }}-{{ s.subjectName }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="h-form-item h-form-item-single">
                    <label class="h-form-item-label" style="width:100px"><span>凭证号：</span></label>
                    <div class="h-form-item-content" style="margin-left:100px">
                      <div class="h-form-item-wrap">
                        <div class="h-input-group">
                          <div class="h-form-item">
                            <div class="h-form-item-content" style="margin-left:0px">
                              <div class="h-form-item-wrap"><input type="text" placeholder="起始凭证号" v-model="queryParam.voucherCodeBegin"></div>
                            </div>
                          </div>
                          <span class="h-input-addon">至</span>
                          <div class="h-form-item">
                            <div class="h-form-item-content" style="margin-left:0px">
                              <div class="h-form-item-wrap"><input type="text" placeholder="结束凭证号" v-model="queryParam.voucherCodeEnd"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <button type="button" class="h-btn" @click="searchReset"><span>重置</span></button>
                  <button type="button" class="h-btn h-btn-primary" style="margin-left:20px" @click="searchQuery"><span>查询</span></button>
                </div>
              </div>
            </div>
          </div>
        </span>
        <span style="float: right;">
          <a-button v-if="btnEnableList.indexOf('1')>-1" type="primary" icon="plus" @click="openAdd">新增</a-button>
          <a-button v-if="btnEnableList.indexOf('1')>-1" style="margin-left: 8px" @click="openBusinessVoucher">业务凭证</a-button>
          <a-button v-if="btnEnableList.indexOf('1')>-1" style="margin-left: 8px" @click="openBusinessTemplate">业务模板</a-button>
          <a-button v-if="btnEnableList.indexOf('2')>-1" style="margin-left: 8px" @click="batchAudit" :disabled="!selected.length">审核</a-button>
          <a-button v-if="btnEnableList.indexOf('2')>-1" style="margin-left: 8px" @click="batchSubmitAudit" :disabled="!selected.length">提交审核</a-button>
          <a-button v-if="btnEnableList.indexOf('2')>-1" style="margin-left: 8px" @click="batchCancelAudit" :disabled="!selected.length">撤回审核</a-button>
          <a-button v-if="btnEnableList.indexOf('7')>-1" style="margin-left: 8px" @click="batchUnAudit" :disabled="!selected.length">反审核</a-button>
          <a-button v-if="btnEnableList.indexOf('1')>-1" style="margin-left: 8px" @click="renumber">整理断号</a-button>
          <a-button v-if="btnEnableList.indexOf('1')>-1" style="margin-left: 8px" @click="batchDelete" :disabled="!selected.length">批量删除</a-button>
          <a-button v-if="btnEnableList.indexOf('1')>-1" style="margin-left: 8px" icon="upload" @click="openImport">导入</a-button>
          <a-button v-if="btnEnableList.indexOf('1')>-1" style="margin-left: 8px" icon="download" @click="handleExport">导出</a-button>
        </span>
      </div>

      <!-- 列表主体 -->
      <div class="voucher-panel-body" :style="{ maxHeight: scrollHeight + 'px', overflowY: 'auto' }">
        <!-- 蓝色表头 -->
        <table class="voucher-header">
          <tr>
            <th style="width:50px;text-align:center">
              <a-checkbox :checked="allChecked" @change="onCheckAll" />
            </th>
            <td style="width:215px">摘要</td>
            <td>科目</td>
            <td style="width:130px;text-align:right">借方金额</td>
            <td style="width:130px;text-align:right">贷方金额</td>
          </tr>
        </table>

        <a-spin :spinning="loading">
          <!-- 每张凭证一个表格 -->
          <table v-for="record in dataSource" :key="record.id" class="details">
            <!-- 头行 -->
            <tr class="details-header">
              <th style="width:50px;text-align:center">
                <a-checkbox :checked="selected.indexOf(record.id)>-1" @change="e => onCheckOne(record, e)" />
              </th>
              <td colspan="2">日期：{{ formatDate(record.voucherDate) }} 凭证字号：{{ record.voucherNo }} 附件：{{ record.receiptNum || 0 }}张
                <template v-if="record.auditorName"> 审核人：{{ record.auditorName }}</template>
                <template v-if="record.sourceBillNo"> 来源：<a @click="traceSource(record)">{{ record.sourceBillNo }}</a></template>
                <template v-if="record.carryForward"> <span style="color:#faad14">[结转]</span></template>
              </td>
              <td colspan="2" class="actions">
                <span class="status-tag" :class="statusClass(record.status)">{{ statusName(record.status) }}</span>
                <span @click="openViewVoucher(record)">查看</span>
                <span @click="openView(record)">追溯</span>
                <span v-if="btnEnableList.indexOf('5')>-1" @click="printVoucher(record)">打印</span>
                <span v-if="btnEnableList.indexOf('1')>-1 && record.status === '0'" @click="openEdit(record)">修改</span>
                <span v-if="btnEnableList.indexOf('1')>-1" @click="copyVoucher(record)">复制</span>
                <span v-if="btnEnableList.indexOf('1')>-1 && record.status === '0'" @click="del(record)">删除</span>
                <span v-if="record.status === '1' && btnEnableList.indexOf('7')>-1" @click="auditOne(record)">反审核</span>
                <span v-if="record.status === '0' && btnEnableList.indexOf('2')>-1" @click="auditOne(record)">审核</span>
                <span v-if="record.status === '0' && btnEnableList.indexOf('2')>-1" @click="submitAuditOne(record)">提交审核</span>
                <span v-if="record.status === '9' && btnEnableList.indexOf('2')>-1" @click="cancelAuditOne(record)">撤回审核</span>
              </td>
            </tr>
            <!-- 分录行 -->
            <tr v-for="(it, i) in (record.items || [])" :key="i">
              <th></th>
              <td style="width:215px">{{ it.summary }}<template v-if="it.auxiliaryTitle"> <span class="item-extra">[{{ it.auxiliaryTitle }}]</span></template></td>
              <td>{{ it.subjectCode }}-{{ it.subjectName }}<template v-if="it.qty !== null && it.qty !== undefined"> <span class="item-extra">数量: {{ it.qty }} 单价: {{ it.price !== null && it.price !== undefined ? it.price : '' }}</span></template></td>
              <td style="width:130px;text-align:right" :class="{ neg: Number(it.debitAmount) < 0 }">{{ it.debitAmount !== null && it.debitAmount !== undefined ? it.debitAmount : '' }}</td>
              <td style="width:130px;text-align:right" :class="{ neg: Number(it.creditAmount) < 0 }">{{ it.creditAmount !== null && it.creditAmount !== undefined ? it.creditAmount : '' }}</td>
            </tr>
            <!-- 合计行 -->
            <tr class="font-bold">
              <td></td>
              <td>合计</td>
              <td></td>
              <td style="text-align:right">{{ record.debitTotal }}</td>
              <td style="text-align:right">{{ record.creditTotal }}</td>
            </tr>
          </table>
          <a-empty v-if="!loading && !dataSource.length" description="暂无凭证" />
        </a-spin>
        <!-- 分页（参照零售出库） -->
        <a-row style="margin-top: 8px;">
          <a-col :span="12" style="line-height: 32px; color: #999;">共 {{ ipagination.total }} 条</a-col>
          <a-col :span="12" style="text-align: right;">
            <a-pagination
              size="small"
              show-size-changer
              show-quick-jumper
              :current="ipagination.current"
              :page-size="ipagination.pageSize"
              :page-size-options="ipagination.pageSizeOptions"
              :total="ipagination.total"
              @change="paginationChange"
              @showSizeChange="paginationShowSizeChange" />
          </a-col>
        </a-row>
      </div>
    </a-card>

    <!-- 导入凭证弹窗 -->
    <a-modal title="导入凭证" :width="480" :visible="importVisible" :footer="null" :maskClosable="false" @cancel="closeImport">
      <div>
        模板：<a @click="downloadTemplate">Excel模板下载</a>
      </div>
      <div style="margin-top: 12px;">
        文件：
        <a-upload accept=".xls" :showUploadList="false" :beforeUpload="beforeImportUpload" :disabled="importing">
          <a-button :loading="importing" icon="upload">上传导入</a-button>
        </a-upload>
      </div>
      <div v-if="importResult" style="margin-top: 16px;">
        <a-alert
          :type="importResult.fail > 0 ? (importResult.success > 0 ? 'warning' : 'error') : 'success'"
          :message="'导入完成：成功 ' + importResult.success + ' 张，失败 ' + importResult.fail + ' 条'"
          showIcon />
        <div v-if="importResult.errors && importResult.errors.length" style="margin-top: 8px; max-height: 200px; overflow-y: auto;">
          <div v-for="(err, i) in importResult.errors" :key="i" style="color: #f5222d; font-size: 12px; line-height: 20px;">{{ err }}</div>
        </div>
      </div>
    </a-modal>

    <!-- 业务凭证弹窗 -->
    <a-modal title="业务凭证" :width="760" :visible="bizVisible" :footer="null" :maskClosable="false" @cancel="bizVisible = false">
      <a-form layout="inline" style="margin-bottom: 12px;">
        <a-form-item label="单据类型"><a-input v-model="bizFilter.docType" style="width:140px" placeholder="仓储单据/财务单据" /></a-form-item>
        <a-form-item label="单据编号"><a-input v-model="bizFilter.number" style="width:160px" /></a-form-item>
        <a-button type="primary" @click="loadPendingDocs">查询</a-button>
        <a-button type="primary" style="float:right" @click="generateVouchers">生成凭证</a-button>
      </a-form>
      <a-table bordered size="middle" rowKey="k" :columns="bizColumns" :dataSource="bizDocs" :pagination="false" />
    </a-modal>

    <!-- 业务模板弹窗 -->
    <a-modal title="业务模板" :width="860" :footer="null" :maskClosable="false" @cancel="tmplVisible = false" :visible="tmplVisible">
      <div style="margin-bottom: 12px;">
        <a-button type="primary" @click="importTemplate">从默认模板全量导入</a-button>
        <a-button style="margin-left:8px" @click="openAddTmpl">新增模板</a-button>
        <a-button style="margin-left:8px" @click="openDefaultTmpl">查看默认模板</a-button>
        <a-button style="float:right" @click="restoreTemplate">恢复默认</a-button>
      </div>
      <a-table bordered size="middle" rowKey="id" :columns="tmplColumns" :dataSource="tmplList" :pagination="false" :loading="tmplLoading">
        <template slot="action" slot-scope="text, record">
          <a style="margin-right:8px" @click="openEditTmpl(record)">编辑</a>
          <a style="color:red" @click="delTmpl(record)">删除</a>
        </template>
      </a-table>
    </a-modal>

    <!-- 默认模板弹窗 -->
    <a-modal title="默认模板" :width="760" :footer="null" :visible="defVisible" @cancel="defVisible = false">
      <a-table bordered size="middle" rowKey="sort" :columns="tmplColumns" :dataSource="defList" :pagination="false" />
    </a-modal>

    <!-- 新增/编辑模板弹窗 -->
    <a-modal :title="tmplForm.id ? '编辑模板' : '新增模板'" :width="560" :visible="addTmplVisible" :confirmLoading="tmplSaving" :maskClosable="false" @ok="saveTmpl" @cancel="addTmplVisible = false">
      <a-form layout="vertical">
        <a-form-item label="业务类型" required>
          <a-select v-model="tmplForm.businessType" placeholder="请选择业务类型">
            <a-select-option v-for="b in bizTypes" :key="b" :value="b">{{ b }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="场景判断">
          <a-select v-model="tmplForm.scenario" placeholder="请选择场景">
            <a-select-option value="无">无</a-select-option>
            <a-select-option value="现付">现付</a-select-option>
            <a-select-option value="预付款">预付款</a-select-option>
            <a-select-option value="盘盈">盘盈</a-select-option>
            <a-select-option value="盘亏">盘亏</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="借方科目">
          <a-input v-model="tmplForm.debitSubjectCode" placeholder="标准科目名称，如 库存商品；结算账户填 @account" />
        </a-form-item>
        <a-form-item label="贷方科目">
          <a-input v-model="tmplForm.creditSubjectCode" placeholder="标准科目名称，如 主营业务收入；结算账户填 @account" />
        </a-form-item>
        <a-form-item label="获取金额">
          <a-select v-model="tmplForm.amountSource" placeholder="请选择金额来源">
            <a-select-option v-for="a in amountSources" :key="a" :value="a">{{ a }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number v-model="tmplForm.sort" :min="1" style="width:100%" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 凭证编辑器（新增/编辑/查看复用） -->
    <voucher-editor
      :visible="editorVisible"
      :mode="editorMode"
      :account-set-id="accountSetId"
      :period="periodStr"
      :voucher-id="editorVoucherId"
      :voucher-ids="voucherIds"
      @update:visible="v => editorVisible = v"
      @navigate="onEditorNavigate"
      @saved="onEditorSaved" />
    </template>

    <!-- 打印模式（内嵌） -->
    <template v-if="printMode">
      <div class="print-header">
        <span class="print-title">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint
        :visible="true"
        :tableData="printRecord ? [printRecord] : []"
        :queryParam="{ period: periodStr }"
        billType="VOUCHER"
        billTypeName="记账凭证"
        :buildData="buildVoucherPrintData"
        :embedded="true"
        @designer-change="onDesignerChange"
        @back="printMode = false" />
    </template>

    <!-- 凭证追溯：原始单据详情（仓储/财务/资产） -->
    <bill-detail ref="billDetail" />
    <financial-detail ref="financialDetail" />
    <asset-bill-print ref="assetPrint"></asset-bill-print>
  </div>
</template>

<script>
import { voucherListPage, voucherAudit, voucherUnAudit, voucherSubmitAudit, voucherCancelAudit, voucherDelete, voucherBatchDelete, voucherRenumber, voucherCopy, accountSetCurrent, businessVoucherPending, businessVoucherGenerate, businessVoucherSourceBill, ruleList, ruleDefault, ruleImportFromDefault, ruleRestore, ruleSave, ruleDelete, voucherExport, voucherImportTemplate, voucherImportFile, voucherWordList, subjectLeafList } from './api'
import { getAction } from '@/api/manage'
import { findBillDetailByNumber } from '@/api/api'
import BillDetail from '@/views/bill/dialog/BillDetail'
import FinancialDetail from '@/views/financial/dialog/FinancialDetail'
import AssetBillPrint from '../fixed-asset/AssetBillPrint.vue'
import { transferGet, repairGet, disposalGet, depBillGet, changeGet } from '../fixed-asset/api/fixedAsset'
import VoucherEditor from './VoucherEditor'
import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
import { buildVoucherPrintData } from './voucherPrintConfig'
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'VoucherList',
  components: { VoucherEditor, ReportPrint, BillDetail, FinancialDetail, AssetBillPrint },
  data() {
    return {
      accountSetId: null, loading: false,
      scrollHeight: 400,
      period: moment(),
      dataSource: [], selected: [],
      // 分页（参照零售出库）
      ipagination: { current: 1, pageSize: 10, pageSizeOptions: ['10', '20', '30', '50'], total: 0 },
      // 查询弹窗筛选条件（参数名与 GET /voucher 接口一致）
      queryVisible: false,
      selectOpen: null,
      queryParam: { voucherWord: null, createMember: null, summary: '', remark: '', subjectId: null, voucherCodeBegin: '', voucherCodeEnd: '', sourceBillNo: '' },
      voucherWords: [], subjects: [], userList: [], filterLoaded: false,
      // 导入
      importVisible: false, importing: false, importResult: null,
      // 按钮权限
      urlPath: '/plugin/gledger/voucher',
      btnEnableList: '',
      // 打印模式（内嵌）
      printMode: false,
      printTitle: '记账凭证-打印预览',
      printRecord: null,
      bizVisible: false, bizDocs: [], bizFilter: { docType: '', number: '' },
      bizColumns: [
        { title: '单据编号', dataIndex: 'number', width: 160 },
        { title: '单据类型', dataIndex: 'docType' },
        { title: '金额', dataIndex: 'amount', width: 100, align: 'right' },
        { title: '是否生成', dataIndex: 'generated', width: 100, customRender: t => t ? '已生成' : '未生成' }
      ],
      tmplVisible: false, tmplList: [], tmplLoading: false,
      tmplColumns: [
        { title: '业务类型', dataIndex: 'business_type', width: 120 },
        { title: '场景判断', dataIndex: 'scenario', width: 90 },
        { title: '借-科目', dataIndex: 'debit_subject_code', width: 160 },
        { title: '贷-科目', dataIndex: 'credit_subject_code', width: 160 },
        { title: '获取金额', dataIndex: 'amount_source', width: 130 },
        { title: '排序', dataIndex: 'sort', width: 60 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 110 }
      ],
      bizTypes: ['零售出库', '零售退货', '采购订单', '销售订单', '采购入库', '采购退货', '销售出库', '销售退货', '收入', '支出', '收款', '付款', '收预付款', '盘点复盘', '资产出库', '资产申领'],
      amountSources: ['收款金额', '付款金额', '欠款金额', '订金金额', '收入金额', '支出金额', '收预付款金额', '盘盈金额', '盘亏金额', '出库金额', '销售成本'],
      addTmplVisible: false, tmplSaving: false, tmplForm: {},
      defVisible: false, defList: [],
      editorVisible: false, editorMode: 'add', editorVoucherId: null
    }
  },
  created() {
    this.initBtnEnableList()
    this.loadCurrent()
  },
  mounted() {
    document.addEventListener('click', this.onDocClick)
    this.$nextTick(() => {
      const el = this.$el.querySelector('.voucher-panel-body')
      if (el) {
        const top = el.getBoundingClientRect().top
        this.scrollHeight = Math.max(300, window.innerHeight - top - 24)
      }
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
  },
  computed: {
    // 期间字符串（YYYY-MM）：a-month-picker 要求 moment 对象，接口传参用字符串
    periodStr() { return this.period ? this.period.format('YYYY-MM') : '' },
    // 当前期间凭证id列表，供编辑器上一条/下一条导航
    voucherIds() { return (this.dataSource || []).map(d => d.id).filter(id => id != null) },
    allChecked() { return this.dataSource.length > 0 && this.selected.length === this.dataSource.length },
    // 查询弹窗下拉选中项显示文本
    voucherWordLabel() {
      const w = this.voucherWords.find(x => x.id === this.queryParam.voucherWord)
      return w ? w.word : ''
    },
    createMemberLabel() {
      const u = this.userList.find(x => x.id === this.queryParam.createMember)
      return u ? u.userName : ''
    },
    subjectLabel() {
      const s = this.subjects.find(x => x.id === this.queryParam.subjectId)
      return s ? s.subjectCode + '-' + s.subjectName : ''
    }
  },
  methods: {
    // 打印数据构建（注册为方法，供模板 :buildData 引用，与负库存统计一致）
    buildVoucherPrintData,
    // 按钮权限初始化
    initBtnEnableList() {
      const btnStrList = Vue.ls.get('winBtnStrList')
      this.btnEnableList = ''
      if (this.urlPath && btnStrList) {
        for (let i = 0; i < btnStrList.length; i++) {
          if (btnStrList[i].url === this.urlPath && btnStrList[i].btnStr) {
            this.btnEnableList = btnStrList[i].btnStr
          }
        }
      }
    },
    // 行内打印（内嵌模式）
    printVoucher(record) {
      if (!record) return
      this.printRecord = record
      this.printTitle = '记账凭证-打印预览'
      this.printMode = true
    },
    onDesignerChange(visible) {
      this.printTitle = visible ? '记账凭证-报表设计' : '记账凭证-打印预览'
    },
    formatDate(v) { return v ? moment(String(v)).format('YYYY-MM-DD') : '' },
    onCheckOne(record, e) {
      const checked = e.target.checked
      if (checked) {
        this.selected.push(record.id)
      } else {
        const index = this.selected.indexOf(record.id)
        if (index > -1) this.selected.splice(index, 1)
      }
    },
    onCheckAll(e) {
      this.selected = e.target.checked ? this.dataSource.map(d => d.id) : []
    },
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) { this.accountSetId = res.data.id; this.loadData() } else { this.$message.warning('尚未建账') }
      })
    },
    loadData() {
      if (!this.accountSetId) return
      this.loading = true
      const [year, month] = this.periodStr.split('-')
      const params = {
        year,
        month,
        page: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        ...this.queryParam
      }
      voucherListPage(params).then((res) => {
        if (res && res.success && res.data) {
          this.dataSource = (res.data.rows || []).map((v, i) => ({ ...v, key: v.id || i }))
          this.ipagination.total = res.data.total || 0
        } else {
          this.dataSource = []
          this.ipagination.total = 0
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    // 切换期间：回到第 1 页
    onPeriodChange() {
      this.ipagination.current = 1
      this.loadData()
    },
    // ==================== 查询弹窗 ====================
    // 打开/关闭查询面板
    toggleQueryPanel() {
      this.queryVisible = !this.queryVisible
      this.selectOpen = null
      if (this.queryVisible) this.loadFilterOptions()
    },
    // 点击页面空白处关闭弹层与下拉
    onDocClick() {
      this.queryVisible = false
      this.selectOpen = null
    },
    // 展开/收起某个自定义下拉
    toggleSelect(field) {
      this.selectOpen = this.selectOpen === field ? null : field
    },
    // 选中下拉项（null=全部，清空条件）
    setQuery(field, v) {
      this.queryParam[field] = v
      this.selectOpen = null
    },
    // 加载下拉数据（凭证字/科目/制单人，仅首次）
    loadFilterOptions() {
      if (this.filterLoaded || !this.accountSetId) return
      this.filterLoaded = true
      voucherWordList({ accountSetId: this.accountSetId }).then((res) => {
        if (res && res.success) this.voucherWords = res.data || []
      })
      subjectLeafList({ accountSetId: this.accountSetId }).then((res) => {
        if (res && res.success) this.subjects = res.data || []
      })
      getAction('/user/getUserList').then((res) => {
        if (res) this.userList = res
      })
    },
    searchQuery() {
      const q = this.queryParam
      if ((q.voucherCodeBegin && !/^\d+$/.test(q.voucherCodeBegin)) || (q.voucherCodeEnd && !/^\d+$/.test(q.voucherCodeEnd))) {
        this.$message.warning('凭证号起止请输入数字')
        return
      }
      this.queryVisible = false
      this.selectOpen = null
      this.ipagination.current = 1
      this.loadData()
    },
    searchReset() {
      this.queryParam = { voucherWord: null, createMember: null, summary: '', remark: '', subjectId: null, voucherCodeBegin: '', voucherCodeEnd: '', sourceBillNo: '' }
      this.queryVisible = false
      this.selectOpen = null
      this.ipagination.current = 1
      this.loadData()
    },
    // 分页（参照零售出库）
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    // ==================== 导入导出 ====================
    openImport() {
      this.importResult = null
      this.importVisible = true
    },
    closeImport() {
      this.importVisible = false
      this.importResult = null
    },
    downloadTemplate() {
      voucherImportTemplate().then((data) => {
        this.saveBlob(data, '凭证导入模板.xls')
      }).catch(() => { this.$message.warning('模板下载失败') })
    },
    beforeImportUpload(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('accountSetId', this.accountSetId)
      this.importing = true
      voucherImportFile(formData).then((res) => {
        this.importing = false
        if (res && res.success) {
          this.importResult = res.data
          if (!res.data.fail) this.$message.success('导入成功 ' + res.data.success + ' 张凭证')
          this.ipagination.current = 1
          this.loadData()
        } else {
          this.$message.error((res && res.message) || '导入失败')
        }
      }).catch(() => {
        this.importing = false
        this.$message.error('导入失败')
      })
      return false
    },
    handleExport() {
      const [year, month] = this.periodStr.split('-')
      voucherExport({ year, month, ...this.queryParam }).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败')
          return
        }
        this.saveBlob(data, '凭证导出.xls')
      }).catch(() => { this.$message.warning('导出失败') })
    },
    saveBlob(data, fileName) {
      if (!data) return
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName)
      } else {
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    },
    statusName(status) {
      if (status === '1') return '已审核'
      if (status === '9') return '审核中'
      return '未审核'
    },
    statusClass(status) {
      if (status === '1') return 'audited'
      if (status === '9') return 'auditing'
      return ''
    },
    auditOne(r) {
      const api = r.status === '1' ? voucherUnAudit : voucherAudit
      api({ id: r.id }).then((res) => { if (res && res.success) { this.$message.success(res.message); this.loadData() } else this.$message.error(res.message || '操作失败') })
    },
    submitAuditOne(r) {
      voucherSubmitAudit(r.voucherNo).then((res) => {
        if (res && res.code === 200) { this.$message.success('已提交审核'); this.loadData() } else this.$message.error((res && res.data && res.data.message) || (res && res.message) || '提交审核失败')
      })
    },
    cancelAuditOne(r) {
      voucherCancelAudit({ id: r.id }).then((res) => {
        if (res && res.success) { this.$message.success(res.message || '撤回审核成功'); this.loadData() } else this.$message.error((res && res.message) || '撤回审核失败')
      })
    },
    batchCancelAudit() {
      // 仅对审核中(9)的凭证撤回
      const targets = this.dataSource.filter(r => this.selected.indexOf(r.id) > -1 && r.status === '9')
      if (!targets.length) { this.$message.warning('请选择审核中的凭证'); return }
      let done = 0
      targets.forEach(r => {
        voucherCancelAudit({ id: r.id }).then(() => {
          done++
          if (done === targets.length) { this.$message.success('已撤回审核 ' + done + ' 张'); this.loadData() }
        }).catch(() => { done++; if (done === targets.length) this.loadData() })
      })
    },
    batchSubmitAudit() {
      // 仅对未审核(0)的凭证发起审批流程
      const targets = this.dataSource.filter(r => this.selected.indexOf(r.id) > -1 && r.status === '0')
      if (!targets.length) { this.$message.warning('请选择未审核的凭证'); return }
      let done = 0
      targets.forEach(r => {
        voucherSubmitAudit(r.voucherNo).then(() => {
          done++
          if (done === targets.length) { this.$message.success('已提交审核 ' + done + ' 张'); this.loadData() }
        }).catch(() => { done++; if (done === targets.length) this.loadData() })
      })
    },
    batchAudit() { this.selected.forEach(id => voucherAudit({ id }).then(() => { })); this.$message.success('已提交审核'); setTimeout(() => this.loadData(), 300) },
    batchUnAudit() { this.selected.forEach(id => voucherUnAudit({ id }).then(() => { })); this.$message.success('已提交反审核'); setTimeout(() => this.loadData(), 300) },
    del(r) { voucherDelete({ id: r.id }).then(() => { this.$message.success('删除成功'); this.loadData() }) },
    batchDelete() { voucherBatchDelete({ ids: this.selected }).then(() => { this.$message.success('批量删除成功'); this.selected = []; this.loadData() }) },
    copyVoucher(r) { voucherCopy({ id: r.id }).then(() => { this.$message.success('复制成功'); this.loadData() }) },
    renumber() { voucherRenumber({ accountSetId: this.accountSetId, period: this.periodStr }).then(() => { this.$message.success('整理断号完成'); this.loadData() }) },
    openAdd() { this.editorMode = 'add'; this.editorVoucherId = null; this.editorVisible = true },
    openEdit(r) { this.editorMode = 'edit'; this.editorVoucherId = r.id; this.editorVisible = true },
    // 查看凭证：任何凭证都打开凭证本身（只读，与新增/编辑同界面）
    openViewVoucher(r) { this.editorMode = 'view'; this.editorVoucherId = r.id; this.editorVisible = true },
    // 凭证规则：浏览器新标签打开，避免污染当前多页签状态
    openRulePage() { window.open(this.$router.resolve('/plugin/gledger/voucherRule').href, '_blank') },
    // 追溯：业务凭证打开原始单据详情，手工凭证打开凭证编辑器查看
    /** 点击来源单号追溯原始单据（复用追溯逻辑） */
    traceSource(r) { this.openView(r) },
    openView(r) {
      if (r.sourceType && r.sourceId) {
        businessVoucherSourceBill({ sourceType: r.sourceType, sourceId: r.sourceId, bizNode: r.bizNode }).then((res) => {
          if (!(res && res.success && res.data)) {
            this.$message.warning((res && res.message) || '原始单据不存在或已删除')
            return
          }
          const { sourceType, number, newType } = res.data
          if (sourceType === 'depot_head') {
            findBillDetailByNumber({ number: number }).then((d) => {
              if (d && d.code === 200) {
                this.$refs.billDetail.isCanBackCheck = false
                this.$refs.billDetail.show(d.data, newType)
                this.$refs.billDetail.title = newType + '-详情'
              }
            })
          } else if (sourceType === 'asset_bill') {
            // 资产凭证追溯：按 bizNode 前缀选资产单据详情接口，用 AssetBillPrint 展示
            const apiMap = { '资产转固': transferGet, '资产核销': transferGet, '资产维修': repairGet, '资产处置': disposalGet, '资产折旧': depBillGet, '资产变动': changeGet }
            const getApi = apiMap[r.bizNode] || transferGet
            getApi(r.sourceId).then((g) => {
              if (g && g.success) {
                const head = (r.bizNode === '资产折旧') ? g.data : (g.data.head || g.data || {})
                const items = g.data.items || g.data.details || []
                this.$refs.assetPrint.show(number, newType, head, items)
              }
            })
          } else {
            this.$refs.financialDetail.show({ billNo: number, type: newType }, newType)
          }
        })
        return
      }
      this.editorMode = 'view'; this.editorVoucherId = r.id; this.editorVisible = true
    },
    onEditorNavigate(id) { this.editorVoucherId = id },
    onEditorSaved() { this.loadData() },
    openBusinessVoucher() { this.bizVisible = true; this.loadPendingDocs() },
    loadPendingDocs() {
      businessVoucherPending(this.bizFilter).then((res) => { if (res && res.success) this.bizDocs = (res.data || []).map((d, i) => ({ ...d, k: d.sourceType + d.sourceId + i })) })
    },
    generateVouchers() { businessVoucherGenerate({}).then((res) => { this.$message.success(res.message || '生成完成'); this.loadPendingDocs(); this.loadData() }) },
    openBusinessTemplate() { this.tmplVisible = true; this.loadTmpl() },
    loadTmpl() {
      this.tmplLoading = true
      ruleList({ accountSetId: this.accountSetId }).then((res) => { if (res && res.success) this.tmplList = res.data || [] }).finally(() => { this.tmplLoading = false })
    },
    importTemplate() { ruleImportFromDefault({ accountSetId: this.accountSetId }).then((res) => { this.$message.success(res.message || '导入完成'); this.loadTmpl() }) },
    restoreTemplate() { ruleRestore({ accountSetId: this.accountSetId }).then((res) => { this.$message.success(res.message || '已恢复默认'); this.loadTmpl() }) },
    openDefaultTmpl() { ruleDefault({}).then((res) => { if (res && res.success) { this.defList = res.data || []; this.defVisible = true } }) },
    openAddTmpl() { this.tmplForm = { businessType: undefined, scenario: '无', debitSubjectCode: '', creditSubjectCode: '', amountSource: undefined, sort: undefined }; this.addTmplVisible = true },
    openEditTmpl(record) { this.tmplForm = { id: record.id, businessType: record.business_type, scenario: record.scenario, debitSubjectCode: record.debit_subject_code, creditSubjectCode: record.credit_subject_code, amountSource: record.amount_source, sort: record.sort }; this.addTmplVisible = true },
    saveTmpl() {
      const f = this.tmplForm
      if (!f.businessType || !f.debitSubjectCode || !f.creditSubjectCode || !f.amountSource) { this.$message.warning('请填写完整'); return }
      const payload = { ...f, accountSetId: this.accountSetId }
      this.tmplSaving = true
      ruleSave(payload).then((res) => {
        if (res && res.success) { this.$message.success('保存成功'); this.addTmplVisible = false; this.loadTmpl() } else this.$message.error(res.message || '保存失败')
      }).finally(() => { this.tmplSaving = false })
    },
    delTmpl(record) {
      this.$confirm({ title: '确认删除该模板?', onOk: () => { return ruleDelete({ id: record.id }).then((res) => { if (res && res.success) { this.$message.success('删除成功'); this.loadTmpl() } else this.$message.error(res.message) }) } })
    }
  }
}
</script>

<style scoped>
/* ==================== 查询下拉弹窗（CSS 照抄 凭证查询.html） ==================== */
/* 触发器：相对定位，弹层挂其正下方（对应参照页 x-placement=bottom-start） */
.query-trigger { position: relative; display: inline-block; margin-left: 8px; }
.h-dropdown { position: absolute; top: 100%; left: 0; margin-top: 4px; z-index: 1000; }
.h-dropdown-inner { transition: .25s cubic-bezier(.24, .22, .015, 1.56); transition-property: transform, opacity; max-height: 500px; transform-origin: top left; }
.h-dropdown-inner > div { box-sizing: border-box; border-radius: 2px; background: #fff; box-shadow: 0 5px 10px rgba(0, 0, 0, .1); }
/* ========== 表单 h-form ========== */
.h-form:after { content: ""; display: block; clear: both; }
.h-form .h-form-item { position: relative; padding-bottom: 10px; }
.h-form .h-form-item-label { display: inline-block; text-align: right; font-size: 13px; color: #555; line-height: 1; padding: 9.5px 15px 9.5px 0; box-sizing: border-box; }
.h-form .h-form-item-content { font-size: 13px; }
.h-form .h-form-item-content .h-input-group,
.h-form .h-form-item-content .h-select,
.h-form .h-form-item-content input[type=text] { width: 100%; }
.h-form .h-form-item-wrap { position: relative; }
.h-form .h-form-item-wrap:after { content: ""; display: block; clear: both; }
.h-form.h-form-single .h-form-item,
.h-form.h-form .h-form-item-single { width: 100%; }
.h-form.h-form-single .h-form-item:after,
.h-form.h-form .h-form-item-single:after { content: ""; display: block; clear: both; }
.h-form.h-form-single .h-form-item .h-form-item-label,
.h-form.h-form .h-form-item-single .h-form-item-label { float: left; }
/* ========== h-select 下拉框 ========== */
.h-select { box-sizing: border-box; vertical-align: middle; position: relative; }
.h-select-placeholder { color: #787878; line-height: 26px; height: 26px; padding-left: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.h-select-selection { line-height: 26px; height: 26px; padding-left: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.h-select-show { padding-right: 25px !important; line-height: 1.5; display: flex; flex-wrap: wrap; }
.h-select-show > .h-icon-down { color: #666; position: absolute; right: 8px; top: 50%; height: 10px; font-size: 12px; line-height: 12px; transform: translateY(-50%) scale(.8); transition: transform .2s; font-style: normal; }
.h-select-show:hover > .h-icon-down { color: #1890ff; }
.h-select-input-border .h-select-show { min-height: 32px; cursor: default; background-color: #fff; border-radius: 2px; border: 1px solid #eee; vertical-align: top; transition: all .2s linear; padding: 2px 2px 0 2px; font-size: 13px; position: relative; box-sizing: border-box; }
.h-select-input-border .h-select-show:hover { border-color: #4ba9ff; }
.h-select-group { outline: none; user-select: none; font-size: 13px; background-color: #fff; padding: 5px 0; }
/* 展开态定位（参照页为收起态快照，此处补充） */
.h-select.h-select-input-border .h-select-group { position: absolute; left: 0; right: 0; top: 100%; margin-top: 2px; z-index: 10; border: 1px solid #eee; border-radius: 2px; box-shadow: 0 5px 10px rgba(0, 0, 0, .1); max-height: 200px; overflow-y: auto; }
.h-select-group .h-select-item { padding: 7px 10px; cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.h-select-group .h-select-item:hover { background-color: #f8f8f8; }
/* ========== h-input-group 输入框组（起始~结束凭证号） ========== */
div.h-input-group { position: relative; display: flex; }
div.h-input-group > div { z-index: 2; margin: 0; flex: 1; padding: 0 !important; }
div.h-input-group > div:not(:last-child) input { border-top-right-radius: 0; border-bottom-right-radius: 0; }
div.h-input-group > .h-input-addon { line-height: 30px; flex: inherit; text-align: center; background-color: #f3f3f3; border-top: 1px solid #eee; border-bottom: 1px solid #eee; height: 32px; vertical-align: middle; padding: 0 5px; min-width: 24px; white-space: nowrap; color: #999; display: inline-block; }
div.h-input-group > .h-input-addon + div input { border-top-left-radius: 0; border-bottom-left-radius: 0; }
/* ========== input 文本输入框 ========== */
input[type=text] { min-width: 1px; position: relative; background-color: #fff; border-radius: 2px; border: 1px solid #eee; display: inline-block; padding: 4px 8px; line-height: 1.5; font-size: 13px; transition: all .2s linear; box-sizing: border-box; -webkit-appearance: none; font-family: inherit; vertical-align: top; outline: none; height: 32px; width: 100%; }
/* ========== h-btn 按钮样式（重置、查询） ========== */
.h-btn { outline: none; padding: 8px 15px; font-family: inherit; display: inline-block; border-radius: 2px; color: inherit; font-size: 13px; line-height: 1; box-sizing: border-box; cursor: pointer; transition: all .2s; border: 1px solid #d3d3d3; box-shadow: 0 1px 1px 0 #eee; background-color: #fff; }
.h-btn:hover { border-color: #65b5ff; color: #65b5ff; }
.h-btn:active { border-color: #0069cb; color: #0069cb; }
.h-btn.h-btn-primary { background-color: #1890ff; color: #fff; }
.h-btn.h-btn-primary:hover { border-color: #4ba9ff; background-color: #4ba9ff; }
.h-btn.h-btn-primary:active { border-color: #007cee; background-color: #007cee; }
.text-center { text-align: center !important; }
/* ==================== 列表主体 ==================== */
.voucher-panel-body { padding: 20px; }
.voucher-panel-body table { width: 100%; border-collapse: collapse; }
.voucher-panel-body table td { padding: 7px; }
.voucher-panel-body .voucher-header { position: sticky; top: 0; z-index: 2; }
/* 蓝色表头 */
.voucher-header { background-color: #1890ff; color: #fff; }
/* 凭证明细表格 */
.details { font-size: 12px; margin: 15px 0; border: 1px solid #eee; }
.details td, .details th { border-bottom: 1px solid #eee; }
.details-header { background-color: #f3f3f3; color: #777; }
.details tr:hover:not(.details-header) { background-color: #dff7df; cursor: pointer; }
.details:hover { box-shadow: 0 0 10px 0 #dadada; border-color: #dadada; }
.font-bold { font-weight: 700; }
/* 负数金额红色 */
.details td.neg { color: #f5222d; }
/* 分录行附加信息（辅助核算/数量单价）：灰色小字 */
.details td .item-extra { color: #999; }
/* 头行操作按钮：默认隐藏，悬停显示 */
.details .actions { text-align: right; padding-right: 20px; }
.details .actions span { display: none; margin-right: 10px; color: #1890ff; cursor: pointer; }
.details:hover .actions span { display: inline-block; }
.details .actions span:hover { text-decoration: underline; }
.details .actions span:last-child { margin-right: 0; }
/* 状态标签（不隐藏，跟随操作区显示） */
.details .actions .status-tag { color: #777; cursor: default; }
.details .actions .status-tag.audited { color: #52c41a; }
.details .actions .status-tag.auditing { color: #fa8c16; }
.details .actions .status-tag:hover { text-decoration: none; }
/* 头行复选框：默认隐藏，悬停显示（与参考样式一致） */
.details .details-header .ant-checkbox-wrapper { display: none; }
.details:hover .details-header .ant-checkbox-wrapper { display: inline-block; }
/* 打印模式标题栏 */
.print-header { display: flex; justify-content: space-between; align-items: center; padding: 8px 16px; background: #fff; border-bottom: 1px solid #e8e8e8; margin-bottom: 12px; }
.print-title { font-size: 16px; font-weight: 500; }
</style>